<style lang="less">
    .main-context {
        overflow-y: auto;
        overflow-x: visible;
        padding: 6px 0;
        div {
            user-select: none;
        }
    }
</style>

<template>
    <div
        class="menu-container main-context-wrapper"
        v-click-outside="closeThis"
        ref="mainContext"
        draggable="false"
        :style="{ top: contextPos[1] + 'px', left: contextPos[0] + 'px' }"
        v-show="showContext"
    >
        <component :is="currentContext" class="main-context"></component>
        <expandContext />
    </div>
</template>

<script lang="ts">
    import expandContext from "./ExpandContext.vue";
    import shapeContext from "./ShapeContext.vue";
    import pageBarContext from "./PageBarContext.vue";
    import pageContext from "./PageContext.vue";
    import libTitleContext from "./LibTitleContext.vue";
    import libContentContext from "./LibContentContext.vue";
    import layerContext from "./LayerContext.vue";
    import { Component, Watch, Prop, Vue } from "vue-property-decorator";

    @Component({
        components: {
            expandContext,
            pageBarContext,
            pageContext,
            shapeContext,
            libTitleContext,
            libContentContext,
            layerContext,
        },
    })
    export default class MainContext extends Vue {
        type: string = "";

        closeExpand() {
            this.$store.commit("setStatus", {
                type: "showContextExpand",
                data: false,
            });
        }
        closeThis() {
            this.$store.state.ui.showContextExpand && window["_view"].expandFloatTool(); // 关闭右键菜单后展开浮动工具栏
            this.$store.commit("closeContext");
        }

        get contextPos() {
            return this.$store.state.ui.contextPos;
        }
        get showContext() {
            return this.$store.state.ui.showContextMenu;
        }
        get contextType() {
            return this.$store.state.ui.contextType;
        }
        get activeContextType() {
            return this.$store.state.ui.activeContextType;
        }
        get currentContext() {
            if (this.activeContextType === this.contextType.pageBar) {
                return "pageBarContext";
            } else if (this.activeContextType === this.contextType.page) {
                return "pageContext";
            } else if (this.activeContextType === this.contextType.shape) {
                return "shapeContext";
            } else if (this.activeContextType === this.contextType.libTitle) {
                return "libTitleContext";
            } else if (this.activeContextType === this.contextType.libContent) {
                return "libContentContext";
            } else if (this.activeContextType === this.contextType.layer) {
                return "layerContext";
            }
        }

        @Watch("showContext")
        onShowContextChanged(val: boolean) {
            let ele = <HTMLElement>this.$refs.mainContext;

            console.log("showContext");
            if (val) {
                this.$nextTick(() => {
                    let contentEle = <HTMLElement>ele.firstElementChild;
                    ele.focus();
                    //当超出屏幕边界的时候，调整位置
                    if (ele.offsetLeft + ele.offsetWidth > window.innerWidth) {
                        ele.style.left = this.contextPos[0] - ele.offsetWidth + "px";
                    }
                    if (ele.offsetTop + ele.offsetHeight > window.innerHeight) {
                        if (ele.offsetHeight + 16 > window.innerHeight) {
                            ele.style.maxHeight = window.innerHeight - 16 + "px"; // 16 means left size off screen.
                            contentEle.style.maxHeight = window.innerHeight - 16 - 6 + "px"; // 6 refer to css class menu-container paddings.
                            ele.style.top = "0px";
                        } else {
                            if (ele.offsetTop < ele.offsetHeight) {
                                ele.style.top = "0px";
                            } else {
                                ele.style.top = this.contextPos[1] - ele.offsetHeight + "px";
                            }
                        }
                    }
                });
            } else {
                this.$nextTick(() => {
                    let contentEle = <HTMLElement>ele.firstElementChild;
                    ele.style.maxHeight = null;
                    contentEle.style.maxHeight = null;
                });
            }
        }
        @Watch("contextPos")
        onPositionChange(nv, ov) {
            if (nv[0] != ov[0] || nv[1] != ov[1]) {
                let ele = <HTMLElement>this.$refs.mainContext;
                this.$nextTick(() => {
                    let contentEle = <HTMLElement>ele.firstElementChild;
                    ele.focus();
                    //当超出屏幕边界的时候，调整位置
                    if (ele.offsetLeft + ele.offsetWidth > window.innerWidth) {
                        ele.style.left = this.contextPos[0] - ele.offsetWidth + "px";
                    }
                    if (ele.offsetTop + ele.offsetHeight > window.innerHeight) {
                        if (ele.offsetHeight + 16 > window.innerHeight) {
                            ele.style.maxHeight = window.innerHeight - 16 + "px"; // 16 means left size off screen.
                            contentEle.style.maxHeight = window.innerHeight - 16 - 6 + "px"; // 6 refer to css class menu-container paddings.
                            ele.style.top = "0px";
                        } else {
                            if (ele.offsetTop < ele.offsetHeight) {
                                ele.style.top = "0px";
                            } else {
                                ele.style.top = this.contextPos[1] - ele.offsetHeight + "px";
                            }
                        }
                    }
                });
            }
        }

        // @Watch('contextPos')
        // onContextPosChanged(val){
        //     if(this.showContext){
        //         this.$nextTick(() => {

        //         });
        //     }
        // }

        //生命周期
        mounted() {}
        created() {}
    }
</script>
